import { faXTwitter, faFacebookF, faYoutube, faInstagram, faTiktok, faSnapchat } from "@fortawesome/free-brands-svg-icons";

const SocialData = [{
    icon: faXTwitter,
    link: "https://x.com/MnstMsar",
},
{
    icon: faFacebookF,
    link: "https://www.facebook.com/MasarAltamioz/",
},
{
    icon: faYoutube,
    link: "https://www.youtube.com/@MasarAltamayuz",
},
{
    icon: faTiktok,
    link: "https://www.tiktok.com/@masar_saudi",
},
{
    icon: faInstagram,
    link: "https://www.instagram.com/masaraltamioz.sa/",
},
{
    icon: faSnapchat,
    link: "https://www.snapchat.com/@masar_altamioz/",
},
];



export default SocialData;